var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6466 13.114C14.6466 13.354 14.5933 13.6006 14.4799 13.8406C14.3666 14.0806 14.2199 14.3073 14.0266 14.5206C13.6999 14.8806 13.3399 15.1406 12.9333 15.3073C12.5333 15.474 12.0999 15.5606 11.6333 15.5606C10.9533 15.5606 10.2266 15.4006 9.45992 15.074C8.69325 14.7473 7.92659 14.3073 7.16659 13.754C6.39992 13.194 5.67325 12.574 4.97992 11.8873C4.29325 11.194 3.67325 10.4673 3.11992 9.7073C2.57325 8.9473 2.13325 8.1873 1.81325 7.43396C1.49325 6.67396 1.33325 5.94729 1.33325 5.25396C1.33325 4.80063 1.41325 4.3673 1.57325 3.9673C1.73325 3.56063 1.98659 3.18729 2.33992 2.85396C2.76659 2.43396 3.23325 2.22729 3.72659 2.22729C3.91325 2.22729 4.09992 2.26729 4.26659 2.34729C4.43992 2.42729 4.59325 2.54729 4.71325 2.72063L6.25992 4.90063C6.37992 5.0673 6.46659 5.22063 6.52659 5.3673C6.58659 5.5073 6.61992 5.6473 6.61992 5.77396C6.61992 5.93396 6.57325 6.09396 6.47992 6.24729C6.39325 6.40063 6.26659 6.56063 6.10659 6.72063L5.59992 7.24729C5.52659 7.32063 5.49325 7.4073 5.49325 7.51396C5.49325 7.5673 5.49992 7.61396 5.51325 7.66729C5.53325 7.72063 5.55325 7.76063 5.56659 7.80063C5.68659 8.02063 5.89325 8.3073 6.18659 8.65396C6.48659 9.00063 6.80659 9.35396 7.15325 9.7073C7.51325 10.0606 7.85992 10.3873 8.21325 10.6873C8.55992 10.9806 8.84659 11.1806 9.07325 11.3006C9.10659 11.314 9.14659 11.334 9.19325 11.354C9.24659 11.374 9.29992 11.3806 9.35992 11.3806C9.47325 11.3806 9.55992 11.3406 9.63325 11.2673L10.1399 10.7673C10.3066 10.6006 10.4666 10.474 10.6199 10.394C10.7733 10.3006 10.9266 10.254 11.0933 10.254C11.2199 10.254 11.3533 10.2806 11.4999 10.3406C11.6466 10.4006 11.7999 10.4873 11.9666 10.6006L14.1733 12.1673C14.3466 12.2873 14.4666 12.4273 14.5399 12.594C14.6066 12.7606 14.6466 12.9273 14.6466 13.114Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3333 6.89388C12.3333 6.49388 12.02 5.88055 11.5533 5.38055C11.1267 4.92055 10.56 4.56055 10 4.56055",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6667 6.89396C14.6667 4.31396 12.58 2.22729 10 2.22729",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.15fbd3b75070fcc55ac21f814cb0ccc3.svg";
export { ForwardRef as ReactComponent };